import { type ContextData } from '@common/defaults/ContextData';
import { getThemeConfigByContext, type ThemeConfig, useThemeConfig } from '@common/hooks/useThemeConfig';

import { type TabbedWidgetConfig } from '../../SimpleWidget/SimpleWidget.types';
import { widgetConfig as mostCommentedConfig } from '../MostCommented';
import { widgetConfig as mostReadConfig } from '../MostRead';
import { widgetConfig as proNewsConfig } from '../ProNews';

export interface NewsPopularThemeConfig {
    tabbedWidgetConfig: TabbedWidgetConfig;
    usePlatformFullNameInHeading: boolean;
    hideTitleUnderlineWhenToggle: boolean;
}

const THEME_CONFIG: ThemeConfig<NewsPopularThemeConfig> = {
    defaults: {
        tabbedWidgetConfig: {
            title: 'popular.title',
            tabs: [mostReadConfig, mostCommentedConfig],
        },
        usePlatformFullNameInHeading: false,
        hideTitleUnderlineWhenToggle: false,
    },
    byPlatform: {
        br: {
            tabbedWidgetConfig: {
                title: 'popular.title',
                tabs: [mostReadConfig],
            },
            usePlatformFullNameInHeading: true,
        },
        vi: {
            tabbedWidgetConfig: {
                title: 'vi.popular.title',
                tabs: [{ ...mostReadConfig, title: 'vi.popular.tab-1-title' }, proNewsConfig],
            },
            hideTitleUnderlineWhenToggle: true,
        },
        vp: {
            hideTitleUnderlineWhenToggle: true,
        },
        vn: {
            hideTitleUnderlineWhenToggle: true,
        },
    },
};

export const getNewsPopularThemeConfig = (contextData: ContextData) =>
    getThemeConfigByContext({ config: THEME_CONFIG, contextData });

export const useNewsPopularThemeConfig = () => useThemeConfig(THEME_CONFIG);
